<template>
  <div class="page-rnr-person-idcard-must-know">
    <div class="page-rnr-person-idcard-must-know-title">拍照须知</div>
    <div class="page-rnr-person-idcard-error-row">
      <div class="page-rnr-person-idcard-error-column smaller">
        <div class="page-rnr-person-idcard-title true">标准拍摄</div>
      </div>
      <div class="page-rnr-person-idcard-error-column lost">
        <div class="page-rnr-person-idcard-title false">边框缺失</div>
      </div>
      <div class="page-rnr-person-idcard-error-column shadow">
        <div class="page-rnr-person-idcard-title false">照片模糊</div>
      </div>
      <div class="page-rnr-person-idcard-error-column light">
        <div class="page-rnr-person-idcard-title false">闪光强烈</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MustKnow'
}
</script>

<style lang="scss">
.page-rnr-person-idcard-must-know {
  padding: 40px 24px 0;
  .page-rnr-person-idcard-must-know-title {
    align-items: center;
    color: #242424;
    display: flex;
    font-size: 28px;
    text-align: center;
    font-weight: 400;
    line-height: 40px;
    &:after, &:before {
      background: #DCDFE6;
      height: 1px;
      transform: scaleY(-1);
      content: "";
      display: block;
      flex: 1;
    }
    &:before {
      margin-right: 12px;
    }
    &:after {
      margin-left: 12px;
    }
  }
  .page-rnr-person-idcard-error-row {
    display: flex;
    margin-top: 24px;
    justify-content: space-between;
    .page-rnr-person-idcard-error-column {
      background-size: 166px 104px;
      background-repeat: no-repeat;
      background-position: left top;
      color: #242424;
      font-size: 24px;
      text-align: center;
      font-weight: 400;
      width: 166px;
      padding-top: 120px;
      text-align: center;
      .page-rnr-person-idcard-title {
        align-items: center;
        display: flex;
        justify-content: center;
        &:before {
          background-size: 100% 100%;
          background-repeat: no-repeat;
          content: "";
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
        &.true {
          &:before {
            background-image: url(../../assets/rnr/ico_true.png);
          }
        }
        &.false {
          &:before {
            background-image: url(../../assets/rnr/ico_false.png);
          }
        }
      }
      &.smaller {
        background-image: url(../../assets/rnr/ico_idcard_smaller.png);
      }
      &.lost {
        background-image: url(../../assets/rnr/ico_idcard_lose.png);
      }
      &.light {
        background-image: url(../../assets/rnr/ico_idcard_light.png);
      }
      &.shadow {
        background-image: url(../../assets/rnr/ico_idcard_shadow.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MustKnow/index.vue